export default __webpack_public_path__ + "static/media/par1.1d113d60.jpg";